export const DMS_MODULE = 'ApprovalWorkflow';
